import React, { memo } from 'react'
import {
  useOpeningHoursItem,
  OpeningHoursItemProps,
} from './useOpeningHoursItem'
import styles from './OpeningHoursItem.module.scss'

const OpeningHoursItem: React.FC<OpeningHoursItemProps> = (
  props: OpeningHoursItemProps
) => {
  const { day, openTime, closeTime, isClosed, bg, text, hoursBg, hoursText } =
    useOpeningHoursItem(props)

  return (
    <div
      className={styles['opening-hours-item']}
      style={{ backgroundColor: bg || '#fff' }}
    >
      <span
        className={styles.day}
        style={{ color: text || 'var(--landing-background-color)' }}
      >
        {day}
      </span>
      {isClosed ? (
        <span
          className={styles.time}
          style={{
            color: hoursText || '#fff',
            backgroundColor: hoursBg || 'var(--landing-primary)',
          }}
        >
          Closed
        </span>
      ) : (
        <div
          className={styles.time}
          style={{
            color: hoursText || '#fff',
            backgroundColor: hoursBg || 'var(--landing-primary)',
          }}
        >
          {openTime} - {closeTime}
        </div>
      )}
    </div>
  )
}

export default memo(OpeningHoursItem)
